<template lang="pug">
	.v-field-text.field-text(:class="computedClass")
		template(v-if="field.type === 'textarea'")
			label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
				| {{field.label}}
				span.field-text__star(v-if="field.required") *
			textarea.field-input(:inputmode="field.inputmode"
				:disabled="field.disabled"
				:placeholder="field.placeholder"
				v-model="localValue"
				@input="handleInput"
				:id="uniqueId")
		template(v-else-if="this.field.mask")
			label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
				| {{field.label}}
				span.field-text__star(v-if="field.required") *
			.field-text__cell
				input.field-input(:type="computedType"
					:inputmode="field.inputmode"
					:disabled="field.disabled"
					:placeholder="field.placeholder"
					:value="localValue"
					:readonly="field?.readonly"
					:id="uniqueId"
					v-imask="computedMask"
					@accept="onAccept"
					@complete="onComplete")
				.field-text__postfix(v-if="field.postfix") {{field.postfix}}
			span.field-input__error-text {{field.errorText}}

		template(v-else)
			label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
				| {{field.label}}
				span.field-text__star(v-if="field.required") *
			.field-text__cell
				v-svg-icon.field-text__icon(v-if="field.icon" :icon="field.icon")
				input.field-input(
					:type="isModifiedType || computedType"
					:inputmode="field.inputmode"
					:disabled="field.disabled"
					:placeholder="field.placeholder"
					:readonly="field?.readonly"
					v-model="localValue"
					@input="handleInput"
					@keyup="handleKeyup"
					:id="uniqueId")
				.field-text__postfix(v-if="field.postfix") {{field.postfix}}
			.field-input__password(v-if="field.type === 'password' && field.change")
				button.icon-btn(@click="changeType('text')" :class="{'icon-btn--crossed' : isModifiedType}" type="button")
					v-svg-icon.icon-btn__icon(icon="eye")
</template>

<script>
	import uniqueId from '../scripts/helpers/uniqueId.js';
	import {MaskedRange} from 'imask'

	export default {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [String, Number],
				default: null
			},

			type: {
				type: String,
				default: null,
			}
		},

		emits: [
			'update:model-value'
		],

		data() {
			return {
				localValue: null,
				savedValue: null,
				unmaskedValue: null,
				maskedvalue: null,
				isModifiedType: true,
				fullUnmaskedValueLength: 0,
				uniqueId: uniqueId('field-text_')
			};
		},

		computed: {

			computedMask() {
				const momentFormat = 'HH:mm';
				if(this.field.mode === 'time') {
					return {
						mask: Date,
						pattern: momentFormat,
						// lazy: false,
						blocks: {
							HH: {
								mask: MaskedRange,
								from: 0,
								to: 23
							},
							mm: {
								mask: MaskedRange,
								from: 0,
								to: 590
							}
						}
					}
				}
				if (this.field.mask.mask === 'Number' && this.field.mode !== 'time') {
					return {
						mask: Number,
						min: this.field.mask.min,
						max: this.field.mask.max,
						radix: this.field.mask.radix,
						mapToRadix: this.field.mask.mapToRadix,
						thousandsSeparator: this.field.mask.thousandsSeparator
					};
				}
				return this.field.mask;
			},

			computedType() {
				if (!this.field.type || this.field.type == 'number') {
					return 'text';
				}
				return this.field.type;
			},

			computedClass() {
				return {
					['field-text--' + this.field.size] : this.field.size,
					['field-text--change'] : this.field.change,
					[this.field.className] : this.field.className
				};
			},

			isFieldNumeric() {
				return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
			}
		},

		watch: {
			modelValue: {
				immediate: true,
				handler() {
					if (this.isFieldNumeric && this.modelValue) {
						this.localValue = this.savedValue = this.modelValue.toString().replace('.', ',');
					} else {
						this.localValue = this.savedValue = this.modelValue;
					}
				}
			}
		},

		methods: {
			changeType(type) {
				this.isModifiedType ? this.isModifiedType = false : this.isModifiedType = type;
			},

			onAccept(e) {
				if (e.detail.unmaskedValue.length !== this.fullUnmaskedValueLength) {
					this.handleInputTel(e);
				}
				if(this.field.mode === 'time') {
					this.handleInputTel(e);
				}
			},

			onComplete(e) {
				this.handleInputTel(e);
			},

			handleKeyup() {
				if (this.isFieldNumeric && this.savedValue) {
					this.localValue = this.savedValue.replace('.', ',');
				}
			},

			handleInputTel(e) {
				this.unmaskedValue = e.detail.unmaskedValue;
				this.maskedvalue = e.detail.value;
				this.fullUnmaskedValueLength = this.unmaskedValue.length;
				if(this.field.mode === 'time') {
					this.$emit('update:model-value', e.detail.value);
					return;
				}

				this.$emit('update:model-value', this.maskedvalue);
			},

			handleInput() {
				if (this.isFieldNumeric) {
					if (!this.localValue || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localValue)) {
						this.savedValue = this.localValue;
					} else {
						this.localValue = this.savedValue;
					}
					this.$emit('update:model-value', this.localValue ? parseFloat(this.localValue.toString().replace(',', '.')) : this.localValue);
				} else if(this.type && this.type === 'translate') {
					this.$emit('update:model-value', {value: this.localValue, lang: this.field?.lang});
				} else {
					this.$emit('update:model-value', this.localValue);
				}
			},

			handleChangeFieldPassType() {
				if (this.field.type === 'password') {
					this.field.type = 'text'
				} else {
					this.field.type = 'password'
				}
			}
		}
	};
</script>
